import React from 'react';

const BuildingSvgComponent = ({ color, style }) => {
  return (
    <svg
      //style={{ width: '15px', marginRight: '6%' }}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.6667 10.6667V2.66667C18.6667 1.2 17.4667 0 16 0H8C6.53333 0 5.33333 1.2 5.33333 2.66667V5.33333H2.66667C1.2 5.33333 0 6.53333 0 8V21.3333C0 22.8 1.2 24 2.66667 24H9.33333C10.0667 24 10.6667 23.4 10.6667 22.6667V18.6667H13.3333V22.6667C13.3333 23.4 13.9333 24 14.6667 24H21.3333C22.8 24 24 22.8 24 21.3333V13.3333C24 11.8667 22.8 10.6667 21.3333 10.6667H18.6667ZM5.33333 21.3333H2.66667V18.6667H5.33333V21.3333ZM5.33333 16H2.66667V13.3333H5.33333V16ZM5.33333 10.6667H2.66667V8H5.33333V10.6667ZM10.6667 16H8V13.3333H10.6667V16ZM10.6667 10.6667H8V8H10.6667V10.6667ZM10.6667 5.33333H8V2.66667H10.6667V5.33333ZM16 16H13.3333V13.3333H16V16ZM16 10.6667H13.3333V8H16V10.6667ZM16 5.33333H13.3333V2.66667H16V5.33333ZM21.3333 21.3333H18.6667V18.6667H21.3333V21.3333ZM21.3333 16H18.6667V13.3333H21.3333V16Z"
        fill={color ? color : '#8C8C8C'}
      />
    </svg>
  );
};

export default BuildingSvgComponent;
